import React, { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import { getUserWiseCollection } from "../../api/accountApi";
import "../Attendance/Attendance.css";

const today = () => new Date().toISOString().slice(0, 10);
const firstOfMonth = () => today().slice(0, 8) + "01";

/**
 * Direct port of digicampusbd's `general-accounts-report-user-wise`
 * ("Financial Transaction User Wise") — credit/debit total per user per
 * ledger for a date range. Confirmed via `GeneralAccountReportService
 * .userWiseCollectionView`'s own native SQL (a plain SUM/GROUP BY, no
 * balances) — new `GET /api/accounts/vouchers/reports/user-wise` endpoint
 * mirrors it verbatim.
 */
export default function UserWiseTransactionPage() {
  const [fromDate, setFromDate] = useState(firstOfMonth());
  const [toDate, setToDate] = useState(today());
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = async () => {
    setError("");
    setLoading(true);
    try {
      setRows(await getUserWiseCollection(fromDate, toDate));
    } catch (err) {
      setError("Failed to load report.");
    } finally {
      setLoading(false);
    }
  };

  const totalCredit = (rows || []).reduce((s, r) => s + r.creditAmount, 0);
  const totalDebit = (rows || []).reduce((s, r) => s + r.debitAmount, 0);

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Financial Transaction User Wise</h1>
      </div>
      {error && <p style={{ color: "var(--color-danger)" }}>{error}</p>}
      <div className="attendance-filters">
        <label>
          From Date
          <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        </label>
        <label>
          To Date
          <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
        </label>
        <button type="button" className="btn-primary" onClick={handleSearch}>
          Search
        </button>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        rows && (
          <div className="table-scroll">
            <table className="attendance-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Ledger</th>
                  <th>Debit</th>
                  <th>Credit</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i}>
                    <td>{r.userName}</td>
                    <td>{r.ledgerName}</td>
                    <td>{r.debitAmount.toFixed(2)}</td>
                    <td>{r.creditAmount.toFixed(2)}</td>
                  </tr>
                ))}
                {rows.length === 0 && (
                  <tr>
                    <td colSpan={4}>No transactions found for this selection.</td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={2} style={{ fontWeight: 800, textAlign: "right" }}>
                    Grand Total
                  </td>
                  <td>
                    <strong>{totalDebit.toFixed(2)}</strong>
                  </td>
                  <td>
                    <strong>{totalCredit.toFixed(2)}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )
      )}
    </MainLayout>
  );
}
